import GameGamepad from "../Game/Gamepad"

const Scenario = {
    "game": {
        // screen : Home.screen,
        gamepad: <GameGamepad />
    }
}

export default Scenario;